export const clamp = (num: number, min: number, max: number): number =>
	Math.max(Math.min(num, max), min)
